import {useCallback} from 'react'
import {useLocation} from 'react-router-dom/cjs/react-router-dom.min'
import {ReactComponent as DuoBadgeCheck} from '../../assets/icons/DuoBadgeCheck.svg'
import {ReactComponent as Logo} from '../../assets/icons/TaVIE-Logo.svg'
import {useAppConfig} from '../../context/app/AppContext'
import {useUserHospital} from '../../context/hospital/UserHospitalContext'
import TranslateUtils from '../../i18n/TranslateUtils'
import {openPage} from '../../utils/NavigatorUtils'
const HospitalOptions = () => {
    const {timezoneId, userRole, hospitalsBelong} = useAppConfig()
    const {currentHospital, onChangeHospital} = useUserHospital()
    const {
        translateCommons,
        translateKeys,
        translateLanguage,
        translateDatatable,
    } = TranslateUtils()
    const location = useLocation()
    console.log(currentHospital)
    const renderListItem = dataItem => {
        return (
            <div className="flex gap-3 align-items-center justify-content-start w-full relative pr-5 py-2">
                {dataItem?.logo ? (
                    <img
                        className=" w-4rem h-3rem m-0  border-circle"
                        src={dataItem?.logo}
                        alt={dataItem.name}
                        style={{
                            objectFit: 'contain',
                        }}
                    />
                ) : (
                    <Logo className=" w-4rem h-2rem m-0  border-circle" />
                )}
                <div className="text-lg font-semibold ">
                    <p className="mb-1">{dataItem.name}</p>
                </div>
                <div className="absolute  right-0">
                    {currentHospital?.id === dataItem?.id && (
                        <DuoBadgeCheck
                            className="text-blue-500"
                            height={28}
                            width={28}
                        />
                    )}
                </div>
            </div>
        )
    }
    const handleOnSelectHospital = useCallback(
        data => {
            onChangeHospital(data)

            if (location.pathname.includes('/patients/')) {
                openPage('/patients')
            } else if (location.pathname.includes('/hcp/')) {
                openPage('/hcp')
            }
        },
        [location.pathname, onChangeHospital],
    )
    return (
        <div className="col-12 ellipsis-container max-w-30rem">
            <div className="flex flex-column mb-1">
                <h5 className="mb-0 font-bold">
                    <span>
                        <i className="pi pi-sync mr-3"></i>
                    </span>
                    {translateKeys('Change Facility')}
                </h5>
            </div>
            <hr className="" />
            <div
                className="flex flex-column gap-2 p-0 align-items-start justify-content-start overflow-y-scroll"
                style={{maxHeight: '450px'}}>
                {hospitalsBelong?.map((item, index) => (
                    <div
                        key={index}
                        className={`col-12 border-round text-sm cursor-pointer ${
                            currentHospital?.id === item?.id
                                ? 'bg-gray-50'
                                : 'hover:surface-50'
                        }`}
                        onClick={() => handleOnSelectHospital(item)}>
                        <div>{renderListItem(item)}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default HospitalOptions
